export function assignLocation(url: string) {
  window.location.assign(url);
}

export function replaceLocation(url: string) {
  window.location.replace(url);
}
